import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'redux/store';
import Checkbox from 'components/checkbox/checkbox';
import { Actions as ProductConfigurationsController } from 'pages/product-flow/pages/product/controllers/product-configurations.controller';
import s from './rename-configuration-modal-content.module.scss';

type Props = {
  name: string;
};

const RenameConfigurationModalContent = ({ name }: Props) => {
  const dispatch = useDispatch();
  const applyRenameToAll = useSelector(
    (state: AppState) => state.product.product_configurations.apply_rename_changes_to_all_versions,
  );

  return (
    <div className={s.rename_configuration_container}>
      <span className={s.text}>
        Change configuration name to <strong>{name}</strong>. Changing the configuration name applies only to active versions.
      </span>
      <div className={s.checkbox_container}>
        <Checkbox
          size="medium"
          checked={applyRenameToAll}
          onClick={() => dispatch(ProductConfigurationsController.onToggleApplyRenameChangesToAllVersions())}
        />
        <b className={s.checkbox_title}>Apply changes to it’s all versions (active and inactive).</b>
      </div>
    </div>
  );
};

export default RenameConfigurationModalContent;
